import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAJR3SFAkcHrn7ek8vihA4xkYpRRtvzYbo",
  authDomain: "myfinap-316ba.firebaseapp.com",
  projectId: "myfinap-316ba",
  storageBucket: "myfinap-316ba.firebasestorage.app",
  messagingSenderId: "1069725084583",
  appId: "1:1069725084583:web:56796a0f99baa1f123a482",
  measurementId: "G-9C2TSES6Y4"
};

// Initialize Firebase only if not already initialized (prevents HMR issues)
let app: FirebaseApp;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Initialize Firebase Authentication and get a reference to the service
const auth: Auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
const db: Firestore = getFirestore(app);

export { auth, db };
export default app;
